import APP_MAIN_PAGE_TYPE from '../types/AppMainPageType.js';

const AppMainPageReducer= (state = initialState,action)=>{
    switch(action.type){
        case APP_MAIN_PAGE_TYPE:
            return Object.assign({}, state, { appMainPage: action.data });
        default:
            return state;
    }
};


const initialState = {
    appMainPage: ''
};

export default AppMainPageReducer;
